/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import React from 'react';

import { SaasName } from '../../../constants/application';
import { Container, TextFooter } from './styles';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const isSaaS = process.env.REACT_APP_SAAS_NAME !== SaasName.EINSTEIN;

  return (
    <Container>
      <TextFooter>
        Copyright © {currentYear}{' '}
        {isSaaS ? 'Plataforma Digital' : 'Einstein Hospital Israelita'} -
        Todos os direitos reservados.
      </TextFooter>
    </Container>
  );
};

export default Footer;
